<div>
<p>Please Login to use Admin features</p>
<button>
<a (click)="loginWithCognito()">Login</a>
</button>
</div>